import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKeyboardDown"><Path d="M10 19L12 21L14 19M9.5 11.25H14.5M1.5 2.5H22.5V15.5H1.5V2.5ZM6 6.5H5.5V7H6V6.5ZM10 6.5H9.5V7H10V6.5ZM14.5 6.5H14V7H14.5V6.5ZM18.5 6.5H18V7H18.5V6.5ZM18.5 11H18V11.5H18.5V11ZM6 11H5.5V11.5H6V11Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconKeyboardDown;
